import React from "react";

// import { Container } from './styles';

const NotFound: React.FC = () => {
    return <div>Página não encontrada</div>;
};

export default NotFound;
